import { gql } from 'apollo-angular';

export const PREFERENCE_CODES = gql`
  query preferenceCodes($search: String, $type: String) {
    preferenceCodes(search: $search, type: $type) {
      id
      category
      prefix
      status
      createdAt
      updatedAt
      deletedAt
      sequenceCode
    }
  }
`;
